<template lang="pug">
#bet-status-single.modal.modal-bottom.fade.modal-bet-status(tabindex='-1' role='dialog' aria-labelledby='bet-status' aria-hidden='true')
  .modal-dialog.modal-dialog-scrollable.m-0(role='document')
    .modal-content
      .modal-body.p-0
        template(v-if="response && response.success")
          .bet-slip
            .stake-info-wrapper
              .bet-status(:class="status ? 'waiting' : (betStatus === 'REJECT') ? 'reject' : 'confirm'")
                span {{ status ? $t('ui.waiting') : (betStatus === 'REJECT') ? $t('ui.reject') : $t('ui.confirm') }}
                template(v-if="status")
                  span.mr-1(v-if="counter > 0") &nbsp;({{ counter + 's' }})
                  span.mr-1(v-else) &nbsp;
                    i.fa.fa-spin.fa-spinner
              .bet-league
                img.icon(:src="'/images/icon-sport-svg/' + getSportsImage(betsingle.sportsType)")
                template(v-if="racingList.includes(betsingle.sportsType)")
                  span {{ sports[betsingle.sportsType] }}
                template(v-else)
                  span {{ sports[betsingle.sportsType] }} - {{ betTypeDisplay }}
              .stake-info
                .betslip-match
                  .team-involved
                    template(v-if="racingList.includes(betsingle.sportsType)")
                      span {{ betsingle.homeName }}
                      span.small.ml-1(v-if="[49, 51].includes(betsingle.sportsType) && betsingle.matchTime") (No. {{ $dayjs(betsingle.matchTime).format("MMDDhhmm") }})
                    template(v-else)
                      .score(v-if="betsingle.marketType == 3 && betsingle.score != ''") {{ betsingle.score }}
                      span(:class="betsingle.giving == 1 && isBallDisplay ? 'team2' : 'team1'") {{ betsingle.homeName }}
                      span.vs(v-if="betsingle.betType != 'OR'") - VS -
                      span(:class="betsingle.giving == 0 && isBallDisplay ? 'team2' : 'team1'" v-if="betsingle.betType != 'OR'") {{ betsingle.awayName }}
                .selector-odd.d-flex.justify-content-between
                  template(v-if="racingList.includes(betsingle.sportsType)")
                    span.bet-type-text(v-if="['OU','OE'].includes(betsingle.betType)") {{ $t("m.GH_" + betsingle.betDisplay.toUpperCase()) }}
                    span.bet-type-text(v-else) {{ $t("m.GH_" + betsingle.betType + (betsingle.ballDisplay == undefined ? '' : betsingle.ballDisplay)) }}
                    .bet-type-odds
                      .odds
                        span(:class="{ 'negetive' : betsingle.val < 0 }") {{ betsingle.val }}
                  template(v-else)
                    span.text(:class="isBallDisplay == false ? '' : ((betsingle.giving == 0 && betsingle.homeAway == 2) ? 'team2' : (betsingle.giving == 1 && betsingle.homeAway == 1) ? 'team2' : 'team1')") {{ betsingle.betType }} | {{ betsingle.betDisplay }}
                    .bet-type-odds
                      span.bet-type-text {{ ballDisplay }}
                      .odds
                        span(:class="{ 'negetive' : betsingle.val < 0 }") {{ betsingle.val }}
              .payout-wrapper
                .left {{ $t("ui.stake")}}: {{ $numeral(betsingle.stake).format("0,0.00[0]") }}
                .right {{ $t("ui.payout")}}: {{ $numeral(betsingle.payout).format("0,0.00[0]") }}
          .btn-continue(@click="hideMe()") {{ $t("ui.continue_bet") }}
</template>

<script>
import { EventBus } from "@/library/_event-bus.js";
import config from "@/config";
import naming from "@/library/_name";
import xhr from "@/library/_xhr-bet.js";

export default {
  components: {},
  data() {
    return {
      betsingle: {},
      items: [],
      response: null,
      status: false,
      betStatus: "",
      checkCounter: null,
      counter: 5
    };
  },
  computed: {
    racingList() {
      return config.racingList;
    },
    isLoggedIn() {
      return this.$store.getters.isLoggedIn;
    },
    ballDisplay() {
      return naming.ballDisplay2(this.betsingle.ballDisplay, this.betsingle.giving, this.betsingle.homeAway, this.betsingle.betType, this);
    },
    isBallDisplay() {
      var result = naming.ballDisplay2(this.betsingle.ballDisplay, this.betsingle.giving, this.betsingle.homeAway, this.betsingle.betType, this);
      if (["HDP", "HDPH"].includes(this.betsingle.betType)) {
        return result != null && result != "0";
      } else {
        return false;
      }
    },
    betTypeDisplay() {
      return this.$t("m.BS_" + this.betsingle.betType);
    },
    commType() {
      return this.$store.getters.commType;
    },
    menu4() {
      return this.$store.getters.menu4;
    },
    debug() {
      return config.debugMode;
    },
    pageDisplay() {
      return this.$store.getters.pageDisplay;
    },
    betting() {
      return this.$store.getters.betting;
    },
    currencyCode() {
      return this.$store.getters.currencyCode.replace('UST', 'USDT');
    },
    isDataExists() {
      if (this.betsingle.hasOwnProperty("val")) {
        return true;
      } else {
        return false;
      }
    },
    sports() {
      return this.$store.state.layout.sports;
    }
  },
  destroyed() {},
  mounted() {
    EventBus.betSingleStatus = this.runbet;
    $("#bet-status-single").on("hidden.bs.modal", () => {
      var _this = this;
      clearInterval(_this.checkCounter);
    });
  },
  methods: {
    getSportsImage(e) {
      return config.getSportsImage(e);
    },
    getBallDisplay(b, g, ha, bt) {
      return naming.ballDisplay2(b, g, ha, bt, this);
    },
    runbet(e, f) {
      this.betsingle = e;
      this.response = f;
      this.status = f.data.pending;
      this.showMe();
    },
    showMe() {
      $("#bet-status-single").modal("show");
      this.betStatus = "";
      if(this.status) {
        this.checkCounter = setInterval(this.handleCounter, 1000);
      }
    },
    hideMe() {
      $("#bet-status-single").modal("hide");
      clearInterval(this.checkCounter);
    },
    handleCounter() {
      if(this.counter > 0) {
        this.counter -= 1;
      } else {
        this.populateList();
        this.counter = 5;
      }
    },
    populateList(callback) {
      if (this.isLoggedIn) {
        this.loading = true;
        var args = {
          account_id: this.$store.getters.accountId,
          session_token: this.$store.getters.sessionToken,
          bet_id: this.response.data.betId,
          bet_type: this.betsingle.betType
        };
        xhr.betStatus(args).then(
          res => {
            this.loading = false;
            if (res.success) {
              if (res.data) {
                var betId = res.data[0].bet_id;
                this.betStatus = res.data[0].bet_status;
                this.status = res.data[0].bet_status === 'PENDING';
                if(this.betStatus != 'PENDING') {
                  clearInterval(this.checkCounter);
                }
                if (callback) callback();
              }
            } else {
              if (this.$helpers.handleFeedback(res.status)) {
                if (callback) callback();
              }
            }
          },
          err => {
            this.loading = false;
            if (this.$helpers.handleFeedback(err.status)) {
              if (callback) callback();
            }
          }
        );
      }
    }
  }
};
</script>
